
  import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
  import Util from '@/lib/util';
  import pagelist from '@/components/pagelistcomponent';
  import AbpBase from '@/lib/abpbase';
  import * as proxy from '@/lib/service-proxies/service-proxies';
  import AppConsts from '@/lib/appconst';
  import PagedFilterAndSortedRequest from '@/store/entities/page-request';
  @Component
  export default class autoruntrade extends pagelist {
    get autoTradeproxy() {
      return new proxy.MerchantServiceProxy();
    }
    model: proxy.ChangePasswordDto = new proxy.ChangePasswordDto();
    get prox() {
            return new proxy.MerchantClientServiceProxy();
        }
        
        created() {
            this.model=new proxy.ChangePasswordDto();
        }
        save() {
            
            (this.$refs.userForm as any).validate(async (valid: boolean) => {
                console.log(valid);
                if (valid) {
                    this.prox.changePassword(this.model).then(() => {
                        this.$Notice.success({title:'保存成功,请重新登陆'});
                        this.$store.commit('app/logout', this);
                        this.$emit('input', false);
                        Util.abp.auth.clearToken();
                        location.reload();
                        this.model = new proxy.ChangePasswordDto();
                    });
                }
            });
        }

        pwdValidate(rule, value, callback) {
            (this.$refs.userForm as any).validateField('againPassword');
            callback();
        };
        pwdCheckValidate (rule, value, callback){
            
            if (!this.model.newPassword && !value) {
                callback(new Error('确认密码不能为空'));
            } else if (this.model.newPassword != value) {
                callback(new Error('新密码和确认密码应相同'));
            } else {
                callback();
            }
        };
    
  }
  